Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PowerLookupListFilter = (function () {

    function PowerLookup () {

        Monet.UI.Fields.PowerLookupList.apply(this, arguments);

        const getFormattedValue = () => {
            let formattedText = '';
            const values = this.getFullValue();
            values.forEach((value) => {
                formattedText += value[this.displayKey] + ', ';
            });
            return formattedText.substring(0, formattedText.length - 2);
        };

        this.updateFormattedValue = () => {
            if (this.getValue().length) {
                this.divLookupList.classList.add('canShowList');
            } else {
                this.divLookupList.classList.remove('canShowList');
            }
            this.formattedValue.value = getFormattedValue();
        };

        this.clear = (options) => {
            const nodes = this.divLookupListWrapper.childNodes;
            while (nodes.length) {
                this.divLookupListWrapper.removeChild(nodes[0]);
            }
            this.listValue = [];
            this.selectedValues = [];
            this.updateFormattedValue();
            this.triggerChange(options);
        };

        this.postRemoveItemCallback = this.updateFormattedValue;

        this.postCreateItemCallback = this.updateFormattedValue;

        this.postRender = function () {
            this.divLookupList.classList.add('lookupListFilter');
        };

        this.clear = (options) => {
          const nodes = this.divLookupListWrapper.childNodes;
          while (nodes.length) {
              this.divLookupListWrapper.removeChild(nodes[0]);
          }
          this.listValue = [];
          this.selectedValues = [];
          this.updateFormattedValue();
          this.triggerChange(options);
      };

    }

    return PowerLookup;

})();